var _effectorFileName = "/src/shared/lib/analytics/facebook-pixel.tsx";
import React from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID;
const isProd = process.env.NODE_ENV === 'production';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}
export const pageviewFB = () => {
  if (typeof window.fbq === 'function' && isProd) {
    window.fbq('track', 'PageView');
  }
};
export const eventFB = (name: string, params?: Record<string, unknown>, options?: {
  custom?: boolean;
}) => {
  if (typeof window.fbq !== 'function' || !isProd) return;
  if (options?.custom) {
    window.fbq('trackCustom', name, params);
  } else {
    window.fbq('track', name, params);
  }
};
export const FacebookPixelScript = () => {
  const router = useRouter();
  React.useEffect(() => {
    router.events.on('routeChangeComplete', pageviewFB);
    router.events.on('hashChangeComplete', pageviewFB);
    return () => {
      router.events.off('routeChangeComplete', pageviewFB);
      router.events.off('hashChangeComplete', pageviewFB);
    };
  }, [router.events]);
  return <>
      <noscript>
        <img height="1" width="1" src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`} />
      </noscript>

      <Script defer id="fb-pixel-init" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${FB_PIXEL_ID}'); 
            fbq('track', 'PageView');
          `
    }} />
    </>;
};